var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@mp/locale';
export default function OffHours(_a) {
    var selectedSlot = _a.selectedSlot;
    // Return null if undefined or true;
    if (selectedSlot.inPolicy !== false) {
        return null;
    }
    return (_jsx("div", __assign({ className: "mp-scheduler-off-hours-message" }, { children: t('CAPTURE_SERVICES.SCHEDULER.offHoursMessage') })));
}
